import { env } from "~/env"

export const isVercelProduction = env.NEXT_PUBLIC_VERCEL_ENV === "production"

export const isVercelPreview = env.NEXT_PUBLIC_VERCEL_ENV === "preview"

export const isVercelDevelopment = env.NEXT_PUBLIC_VERCEL_ENV === "development"
